__turbopack_context__.v({
  "avatarGroupWrapper": "MemberAccessDialog-module__sDnw-G__avatarGroupWrapper",
  "renderAvatarWrapper": "MemberAccessDialog-module__sDnw-G__renderAvatarWrapper",
  "resourceAvatarWrapperWithResourceImage": "MemberAccessDialog-module__sDnw-G__resourceAvatarWrapperWithResourceImage",
});
